import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const CalloutIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props} ref={ref}>{'\ue88e'}</MuiIcon>
        );
    }
);

